const defualtState = {
    username: '',
    password: '',
    error: null,
};

export default (state = defualtState, action) => {
    switch (action.type) {
        case 'SET_LOGIN_STATE': {
          const {username, password} = action;
          return {
            ...state,
            username,
            password
          };
        }
        case 'LOGIN_ERROR': {
          const {error} = action;
          return {
            ...state,
            error
          };
        }

        default:
            return state
    }
}
